import React from 'react';
import { Box, CircularProgress, Backdrop } from '@mui/material';

function LoadingOverlay({ open, message }) {
  return (
    <Backdrop
      open={open}
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        flexDirection: 'column',
        gap: 2
      }}
    >
      <CircularProgress color="inherit" />
      {message && (
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          {message}
        </Box>
      )}
    </Backdrop>
  );
}

export default LoadingOverlay;

